<template>
    <div class="filters-loop-wrapper" v-click-outside="closeAllFilterDropdown">
        <component
            v-for="(filter, index) in orderedFilters"
            :is="resolveFilterComponent(filter.type)"
            :key="getFilterComponentKey(filter, index)"
            v-bind="getFilterProps(filter)"
            @get-value="store"
        />
    </div>
</template>


<script>
import AvatarFilter from "./AvatarFilter";
import RangeFilter from "./RangeFilter";
import CheckboxFilter from "./CheckboxFilter";
import DropDownFilter from "./DropDownFilter";
import RadioFilter from "./RadioFilter";
import DateRangeFilter from "./DateRangeFilter";
import coreLibrary from '../../helpers/CoreLibrary';
import DropdownMenuFilter from "./DropdownMenuFilter";
import MultiSelectFilter from "./MultiSelectFilter";
import DateFilter from "./DateFilter";
import TabFilter from "./TabFilter";
import ToggleFilter from "./ToggleFilter";
import SearchAndSelectFilter from "./SearchAndSelectFilter";

export default {
    name: "AppFilter",
    extends: coreLibrary,
    components: {
        AvatarFilter,
        RadioFilter,
        DateRangeFilter,
        DropDownFilter,
        CheckboxFilter,
        RangeFilter,
        DropdownMenuFilter,
        MultiSelectFilter,
        DateFilter,
        TabFilter,
        ToggleFilter,
        SearchAndSelectFilter
    },
    props: {
        tableId: String,
        filters: {
            required: true,
            type: Array,
        },
        options: {}
    },
    data() {
        return {
            filterValues: {}
        }
    },
    computed: {
        filterComputed() {
            let keys = [],
                filtersWP = this.filters.filter(item => (this.isUndefined(item.permission) || item.permission));

            filtersWP.forEach(i => {
                let k = _.snakeCase(_.lowerCase(i.key)),
                    t = _.kebabCase(_.lowerCase(i.type)),
                    v = {'title': i.title, 'key': k, 'type': t};

                if (i.option) {
                    v.option = i.option;
                }

                if (!this.isUndefined(i.active) || !this.isUndefined(i.initValue)) {
                    v.active = !this.isUndefined(i.active) ? i.active : i.initValue;
                }

                if (!this.isUndefined(i.default)) {
                    v.default = i.default;
                }

                if (i.header) {
                    v.header = i.header;
                }

                if (i.listValueField) {
                    v.listValueField = i.listValueField;
                }

                if (i.buttonLabel) {
                    v.buttonLabel = i.buttonLabel;
                }

                if (i.type === 'range-filter') {
                    v.maxTitle = i.maxTitle;
                    v.minTitle = i.minTitle;
                    v.sign = i.sign;

                    if (!this.isUndefined(i.minRange)) {
                        v.minRange = i.minRange;
                    }

                    if (!this.isUndefined(i.maxRange)) {
                        v.maxRange = i.maxRange;
                    }
                }

                if (i.type === 'avatar-filter') {
                    if (!this.isUndefined(i.imgRelationship)) {
                        v.imgRelationship = i.imgRelationship;
                    }

                    if (!this.isUndefined(i.imgKey)) {
                        v.imgKey = i.imgKey;
                    }
                }

                if (i.type === 'search-and-select-filter' && i.settings) {
                    v.settings = i.settings;
                }

                keys.push(v);
            });

            return keys;
        },
        preferredPrimaryFilterKeys() {
            if (!this.options || !Array.isArray(this.options.primaryFilters)) {
                return [];
            }

            return this.options.primaryFilters.map(key => this.normalizeFilterKey(key));
        },
        orderedFilters() {
            if (!this.preferredPrimaryFilterKeys.length) {
                return this.filterComputed;
            }

            let filtersByKey = this.filterComputed.reduce((carry, filter) => {
                    carry[filter.key] = filter;
                    return carry;
                }, {}),
                pinnedFilters = this.preferredPrimaryFilterKeys
                    .map(key => filtersByKey[key])
                    .filter(filter => !!filter),
                pinnedFilterKeys = new Set(pinnedFilters.map(filter => filter.key));

            return [
                ...pinnedFilters,
                ...this.filterComputed.filter(filter => !pinnedFilterKeys.has(filter.key))
            ];
        }
    },
    methods: {
        store(v) {
            this.$set(this.filterValues, v.key, v.value);
            this.$emit('get-values', this.filterValues);
        },
        closeAllFilterDropdown() {
            $(`.filters-loop-wrapper .dropdown-menu.show`).removeClass('show')
        },
        normalizeFilterKey(key) {
            return _.snakeCase(_.lowerCase(key));
        },
        resolveFilterComponent(type) {
            const componentMap = {
                'range-picker': DateRangeFilter,
                'range-filter': RangeFilter,
                'checkbox': CheckboxFilter,
                'radio': RadioFilter,
                'drop-down-filter': DropDownFilter,
                'dropdown-menu-filter': DropdownMenuFilter,
                'search-and-select-filter': SearchAndSelectFilter,
                'multi-select-filter': MultiSelectFilter,
                'date': DateFilter,
                'tab-filter': TabFilter,
                'avatar-filter': AvatarFilter,
                'toggle-filter': ToggleFilter
            };

            return componentMap[type];
        },
        getFilterProps(filter) {
            const baseProps = {
                tableId: this.tableId,
                filterKey: filter.key,
                active: filter.active,
                default: filter.default
            };

            switch (filter.type) {
                case 'range-picker':
                    return {
                        ...baseProps,
                        label: filter.title,
                        visibleValue: false,
                        presetRanges: filter.option
                    };
                case 'range-filter':
                    return {
                        ...baseProps,
                        label: filter.title,
                        maxRange: filter.maxRange,
                        minRange: filter.minRange,
                        maxTitle: filter.maxTitle,
                        minTitle: filter.minTitle,
                        sign: filter.sign
                    };
                case 'checkbox':
                case 'radio':
                case 'tab-filter':
                    return {
                        ...baseProps,
                        label: filter.title,
                        filterOption: filter.option,
                        listValueField: filter.listValueField,
                        header: filter.header
                    };
                case 'drop-down-filter':
                    return {
                        ...baseProps,
                        id: `${filter.key}-${this.tableId}`,
                        list: filter.option,
                        label: filter.title,
                        listValueField: filter.listValueField
                    };
                case 'dropdown-menu-filter':
                case 'multi-select-filter':
                case 'search-and-select-filter':
                    return {
                        ...baseProps,
                        list: filter.option,
                        label: filter.title,
                        listValueField: filter.listValueField,
                        settings: filter.settings
                    };
                case 'date':
                    return {
                        ...baseProps,
                        label: filter.title
                    };
                case 'avatar-filter':
                    return {
                        ...baseProps,
                        imgRelationship: filter.imgRelationship,
                        imgKey: filter.imgKey,
                        list: filter.option,
                        label: filter.title,
                        listValueField: filter.listValueField
                    };
                case 'toggle-filter':
                    return {
                        ...baseProps,
                        label: filter.title,
                        header: filter.header,
                        buttonLabel: filter.buttonLabel
                    };
                default:
                    return baseProps;
            }
        },
        getFilterComponentKey(filter, index) {
            return `${filter.type}-${filter.key}-${index}`;
        }
    },
    mounted() {
        this.$hub.$on('clearAllFilter-' + this.tableId, () => {
            this.filterValues = {};
        });
    }
}
</script>
